// extracted by mini-css-extract-plugin
module.exports = {"btnGreen":"styles_btnGreen__XAn85","btnRed":"styles_btnRed__lz0wx","container":"styles_container__B8vdO","wrapper":"styles_wrapper__2Q4xf"};